import ReactIcon from "../../../../assets/icons/about/ItemSkill/ReactJSHover.svg";
import UnityIcon from "../../../../assets/icons/about/ItemSkill/unityHover.svg";

import imgGameSvg from '../../../../assets/icons/tabs/gameHover.svg'
import MobileSvg from '../../../../assets/icons/about/ItemSkill/MobileIcon.svg'


export const imgIcon = {
  reactImg: ReactIcon,
  unityImg: UnityIcon,

	gameImg: imgGameSvg,
	mobileImg: MobileSvg,
}